
        var result = require("!!../../../../../node_modules/css-loader/index.js!./quote-templates.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./ClientApp/app/components/quote-settings/quote-templates/quote-templates.component.css
// module id = 738
// module chunks = 0